import { ButtonGroup } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import TenantPage from 'layouts/TenantPage';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AddRoleNameDialog from '../components/AddRoleNameDialog';
import { roleNameService } from '../api/role-name.service';
import { LinkButton, AddButton } from 'components/ui';
import { RoleNameColumns } from '../role-names';

function RoleNameList() {
  const translationPrefix = 'pages.role-names.list';
  const { t } = useTranslation();

  const [addDialog, setAddDialog] = useState(false);

  const columns: GridColDef[] = RoleNameColumns();
  const refreshTable = useRef();

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      menuRight={
        <ButtonGroup size="small" variant="outlined">
          <LinkButton to="by-role" prefix={translationPrefix} label="by-role" />
          <AddButton
            prefix={translationPrefix}
            requireTenantAdmin
            onClick={() => {
              setAddDialog(true);
            }}
          />
        </ButtonGroup>
      }>
      <EnhancedDataGrid columns={columns} service={roleNameService} refresh={refreshTable} />
      <AddRoleNameDialog open={addDialog} setOpen={setAddDialog} callback={refreshTable.current} />
    </TenantPage>
  );
}

export default RoleNameList;
